import { useEffect, useState } from "react";
import { getUpdatedStatus } from "../../../utils/statusUtils";
import type { LastStatusEnum } from "../../../services/exploreListings";

interface StateHome {
  state: string;
  color: string;
  desc?: string;
}

export const useStatus = (lastStatus: LastStatusEnum) => {
  const [status, setStatus] = useState<StateHome>({
    state: "",
    color: "",
    desc: "",
  });

  useEffect(() => {
    const updatedStatus = getUpdatedStatus(lastStatus);
    setStatus(updatedStatus);
  }, [lastStatus]);

  return status;
};
